import HTTP from './http-request-handler'

const assetService = {
  downloadImage: function (image) {
    return HTTP.get('document/download', { params: { ...image } })
      .then(response => {
        if (response.status === 200) {
          return response.data
        } else {
          return Promise.reject(new Error(`Error in fetchings page`))
        }
      }).catch(e => { return e })
  },
  adminProfile: function () {
    return HTTP.get('profile')
      .then(response => {
        if (response.data.status === 'success') {
          return response.data.message
        } else {
          return 'Unable to fetch profile details'
        }
      }).catch(e => {
        return e
      })
  },
  list: function (obj) {
    return HTTP.get('document/list?document_type=' + obj)
      .then(response => {
        return response.data
      }).catch(e => {
        return e
      })
  },
  getFreeEmailProviders:  function () {
    return HTTP.get('getFreeEmailProviders')
      .then(response => {
        return response.data.result
      }).catch(e => {
        return e
      })
  },
  getBannerModes:  function () {
    return HTTP.get('getModes')
      .then(response => {
        return response.data.result
      }).catch(e => {
        return e
      })
  },
}
export default assetService
